import RadioButton from "@/components/RadioButton"
import Tooltip from "@/components/Tooltip"
import cn from "@/utils/cn"
import { RadioGroup } from "@headlessui/react"
import { ComponentPropsWithoutRef } from "react"

type ButtonGroupProps<T> = ComponentPropsWithoutRef<typeof RadioGroup> & {
  values: { value: T; title: string; disabled?: boolean; tooltip?: string }[]
  variant: ButtonGroupVariant
  customCheckedStyles?: string
  onClick?: (value: T) => void
}

type ButtonGroupVariant = "rounded" | "rectangle"

const ButtonGroup = <T extends string>({
  values,
  disabled: groupDisabled = false,
  className,
  variant,
  customCheckedStyles,
  onClick,
  ...otherProps
}: ButtonGroupProps<T>) => {
  return (
    <RadioGroup
      disabled={groupDisabled}
      className={cn("inline-flex flex-wrap items-center gap-2", className)}
      {...otherProps}
    >
      {values.map(({ value, title, disabled, tooltip }) => (
        <Tooltip key={value} content={tooltip}>
          <RadioButton
            value={value}
            disabled={groupDisabled || disabled}
            className={cn(
              "bg-white",
              variant === "rounded" ? "rounded-full" : "",
              customCheckedStyles ? customCheckedStyles : ""
            )}
            onClick={() => onClick?.(value)}
          >
            {title}
          </RadioButton>
        </Tooltip>
      ))}
    </RadioGroup>
  )
}

export default ButtonGroup
